module.exports = __webpack_public_path__ + "static/media/red_location_pin.4488899b.svg";